<template>
  <v-select
    label='Type'
    class="white"
    :items="datasetType"
    item-text="name"
    item-value="value"
    v-model="inputVal"
  ></v-select>
</template>

<script>

  import datasetType from '@/datasets/schoolType'
export default {
  props: ["callbackSelect", "callbackError","value"],
  data: () => ({
    data: [],
    id: null,
    item: null,
    datasetType:datasetType,
  }),
  created() {

  },
   computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
   
  },
  mounted() {
      this.item = datasetType[0];
  },
};
</script>
